import React from 'react';
import SecurityIcon from '@mui/icons-material/Security';
import LegalPage from '../../components/Legal/LegalPage';

/** Gizlilik Politikası — sade özet; hukuki ayrıntılar /kvkk sayfasında. */
const Privacy = () => <LegalPage ns="privacy" docKey="privacy" icon={<SecurityIcon />} />;

export default Privacy;
